<template>
    <div>
        <v-timeline-item :position="tiempo.position" v-for="(tiempo, i) in pasos" :key="i"
        :bg-color="(informacion.status_id == tiempo.status) ? 'primary' : (informacion.status_id > tiempo.status && informacion.status_id < 6) ? 'success' : 'secondary'">
            <div class="card" :class="(informacion.status_id == tiempo.status) ? 'border-primary' : ''">
                <div class="card-header">
                    {{tiempo.title}}
                </div>
                <div class="card-body">
                    <div v-if="informacion.status_id == tiempo.status" class="alert alert-primary" role="alert">
                        {{tiempo.tooltip}}
                    </div>
                    
                    <button v-if="([6,7]).includes(informacion.status_id)" class="btn btn-sm btn-warning mb-2"
                        @click="postReactivar(tiempo.status, informacion.id)">
                        Reactivar en esta etapa
                    </button>
                    <div class="dropdown mb-4">
                        <div v-if="informacion.status_id == tiempo.status">
                            <button class="btn btn-primary btn-sm dropdown-toggle mb-3" type="button" data-toggle="dropdown">
                                <i class="far fa-plus-square pr-1"></i>
                                Acciones
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <button v-if="tiempo.inscripcion == true" class="dropdown-item" >
                                        <a :href="'/proceso-inscripcion/persona/' + window.btoa(informacion.persona_id)" target="_blank">
                                            Inscripción académica
                                        </a>
                                    </button>
                                    <button v-if="tiempo.pagar == true" class="dropdown-item" >
                                        <a :href="'/finanzas/' + window.btoa(informacion.persona_id)" target="_blank">
                                            Pago de inscripción
                                        </a>
                                    </button>
                                    <button class="dropdown-item" data-toggle="collapse" data-target="#comentario1"
                                        aria-expanded="false" aria-controls="comentario1">
                                        Hacer un comentario
                                    </button>
                                    <!-- <button class="dropdown-item"
                                        id="#enviarCorreo"
                                        @click="abrirCorreoModal(tiempo.status)">
                                        Enviar correo
                                    </button> -->
                                    <button v-if="tiempo.avanzar == true" class="dropdown-item" @click="postAvanzar(informacion.id, tiempo.status)">Avanzar a la siguiente etapa</button>
                                    <button v-if="tiempo.retroceder == true" class="dropdown-item" @click="postRetroceder(informacion.id)">Retroceder la etapa</button>
                                    <button class="dropdown-item" @click="postCongelar(informacion.id)">Congelar</button>
                                    <button class="dropdown-item" @click="postDescartar(informacion.id)">Descartar</button>
                            </div>
                            <h6 class="m-0 mb-1 mt-2">Comentarios</h6>
                            <div class="collapse" id="comentario1">
                                <textarea v-model="comentarios" class="form-control" id="exampleFormControlTextarea1" rows="3" placeholder="Hacer un comentario..."></textarea>
                                <div class="text-right mt-1 comment-area">
                                    <button data-toggle="collapse" data-target="#comentario1" class="btn btn-outline-danger btn-sm" style="color: red;">Cancelar</button>
                                    <button data-toggle="collapse" data-target="#comentario1" class="ml-2 btn btn-primary  btn-sm" @click="publicarComentario(informacion.id)">Publicar</button>
                                </div>
                            </div>
                        </div>
                        <h6 class="m-0 mb-1 mt-2" v-if="informacion.status_id != tiempo.status">Comentarios</h6>
                        <v-comment v-for="item in informacion.comentarios" :key="item.id" v-if="item.status_id == tiempo.status" :avatar="item.avatar" :nuevo="item.nuevo" :title="item.user.name" :subtitle="item.created_at" :comment="item.comentario">
                        </v-comment>
                        <hr>
                        <h6 class="m-0 mb-1">Correos enviados</h6>
                        <div v-for="(correo) in informacion.correos" 
                            :key="correo.id+'c'" class="list-group">
                            <div v-if="correo.status_id == tiempo.status"
                                class="list-group-item p-3 m-1">
                                <p class="m-0">
                                    <span class="text-primary">Asunto: </span>
                                    <span v-text="correo.asunto"></span>
                                </p>
                                <p class="m-0">
                                    <span class="text-danger">Emisor: </span>
                                    <span v-text="correo.user.name"></span>
                                </p>
                                <hr class="my-1">
                                <p class="m-0" v-text="correo.mensaje"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </v-timeline-item>
        <correo v-model="activeCorre" :correo="correo"></correo>
        <curp v-model="activeCurp" :informacion="informacion" @refreshProcess="getInformacionProcesoAdmision"></curp>
    </div>

</template>

<script>
import landing from '../../../../api/requests/landing'
import Crear from '../../../administracion/promociones/modal/crear.vue'
import correo from './modal/correo.vue'
import curp from './modal/curp.vue'
export default {
    props:[
        'personaId'
    ],
    data(){
        return{
            informacion: [],
            comentarios: '',
            correo: [],
            activeCorre: false,
            pasos: [
                {
                    'position': 'left',
                    'status': 1,
                    'title': 'Etapa informes (Prospecto)',
                    'tooltip': 'Cliente potencial que llega a través de alguna activación descrita en la estrategia de promoción de cada Colegio.',
                    'avanzar': true,
                    'retroceder': false,
                    'pagar': false,
                    'inscripcion': false
                },
                {
                    'position': 'right',
                    'status': 2,
                    'title': 'Etapa informes (Interesado)',
                    'tooltip': 'Contacto calificado y validado; tiene una necesidad y parece estar interesado en el Colegio. En lenguaje coloquial, se le conoce como una persona interesada.',
                    'avanzar': true,
                    'retroceder': true,
                    'pagar': false,
                    'inscripcion': false
                },
                {
                    'position':'left',
                    'status': 3,
                    'title': 'Etapa valoración (Aplicante)',
                    'tooltip': 'Aquel interesado que ya comenzó un proceso institucional como llenar solicitud, entrega de informes, entrega de documentación y tienen agendado un examen diagnóstico.',
                    'avanzar': true,
                    'retroceder': true,
                    'pagar': false,
                    'inscripcion': false
                },
                {
                    'position':'right',
                    'status': 4,
                    'title': 'Etapa valoración (Admitido)',
                    'tooltip': 'Todo aquel aplicante que realizó/acreditó el examen diagnóstico o que está admitido al Colegio por cualquier otro medio (promoción, pase directo, etc.)',
                    'avanzar': true,
                    'retroceder': true,
                    'pagar': true,
                    'inscripcion': false
                },
                {
                    'position':'left',
                    'status': 5,
                    'title': 'Etapa inscripción (Inscrito económico)',
                    'tooltip': 'Se divide en dos: inscrito académico y el inscrito económico. El inscrito académico, es aquel alumno que ya acreditó/realizó su examen y ya entregó toda la documentación necesaria. El inscrito económico es aquel que únicamente ha pagado.',
                    'avanzar': false,
                    'retroceder': true,
                    'pagar': false,
                    'inscripcion': true
                }
            ],
            activeCurp: false
        }
    },
    created(){
        this.getInformacionProcesoAdmision()
    },
    components:{
        correo,
        Crear,
        curp
    },
    methods:{
        async getInformacionProcesoAdmision(){
            try{
                const url = window.location.pathname.split('/')
                const lastUrl = url.pop()
                const {data: response} = await landing.getInformacionProcesoAdmision(this.personaId, lastUrl)
                this.informacion = response
            }catch(error){
                console.log(error)
            }
        },
        async publicarComentario(){
            const loading = this.$vs.loading()
            try{
                const params = {
                    comentario: this.comentarios
                }
                const payload = Object.assign(params)
                const response = await landing.publicarComentario(payload, this.informacion.id)
                this.getInformacionProcesoAdmision()
                loading.close()
            }catch(error){
                loading.close()
                console.log(error)
            }
        },
        abrirCorreoModal(status){
            this.correo = {
                prospecto_id: this.personaId,
                status_id: status
            }
            this.activeCorre =! this.activeCorre
        },
        async postCongelar(id){
            const loading = this.$vs.loading()
            try{
                const response = await landing.postCongelar(id)
                this.getInformacionProcesoAdmision()
                loading.close()
            }catch(error){
                console.log(error)
                loading.close()
            }
        },
        async postReactivar(status, id){
            const loading = this.$vs.loading()
            try{
                const response = await landing.postReactivar(status, id)
                this.getInformacionProcesoAdmision()
                loading.close()
            }catch(error){
                console.log(error)
                loading.close()
            }
        },
        async postDescartar(id){
            const loading = this.$vs.loading()
            try{
                const response = await landing.postDescartar(id)
                this.getInformacionProcesoAdmision()
                loading.close()
            }catch(error){
                console.log(error)
                loading.close()
            }
        },
        async postAvanzar(id, status){
            if(status == '3'){
                this.activeCurp =! this.activeCurp
            }else{
                const formData = new FormData()
                formData.append('confirmacion_vinculacion', '')
                const loading = this.$vs.loading()
                try{
                    const response = await landing.postAvanzar(id, formData)
                    this.getInformacionProcesoAdmision()
                    if(response.data.status_id == '5'){
                        location.reload();
                    }
                    loading.close()
                }catch(error){
                    console.log(error)
                    loading.close()
                }

            }
        },
        async postRetroceder(id){
            const loading = this.$vs.loading()
            try{
                const response = await landing.postRetroceder(id)
                this.getInformacionProcesoAdmision()
                if(response.data.status_id == '4'){
                    location.reload();
                }
                loading.close()
            }catch(error){
                console.log(error)
                loading.close()
            }
        },
    },
    watch:{
        datos(){
            this.getInformacion()
        }
    }
}
</script>